import { useQuery } from "react-query";
import { CasProfileApi } from "@jti/rest-api";
export const useUserProfile = () => {
    const { data } = useQuery("profile", () => CasProfileApi.init().getProfile());
    return data?.personalInfo || null;
};
//# sourceMappingURL=useUserProfile.js.map